<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd">新增账号</el-button>
      </el-form-item>
      <el-form-item>
        <span class="hint">财务：全部操作；前台：查询、录入收支、照片识别、充电桩录入；老板/股东：只能查询。改动在对方下一次操作时生效。</span>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="users" v-loading="loading" border style="width: 100%;">
      <el-table-column prop="loginUsername" label="登录名" width="140"></el-table-column>
      <el-table-column prop="displayName" label="显示名" width="120" :formatter="row => row.displayName || '-'"></el-table-column>
      <el-table-column prop="roleLabel" label="角色" width="120"></el-table-column>
      <el-table-column label="负责的公寓" min-width="220">
        <template slot-scope="scope">
          <el-tag v-for="name in scope.row.companyNames" :key="name" size="mini" class="company-tag">{{ name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.userId ? '修改账号 ' + form.loginUsername : '新增账号'" :visible.sync="dialogVisible" width="460px">
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <el-form-item label="登录名" prop="loginUsername">
          <el-input size="small" v-model="form.loginUsername" :disabled="!!form.userId" placeholder="字母或数字，如 zhaojie"></el-input>
        </el-form-item>
        <el-form-item label="显示名">
          <el-input size="small" v-model="form.displayName" placeholder="如 赵姐（选填）"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="form.role">
            <el-radio label="FINANCE">财务</el-radio>
            <el-radio label="FRONT_DESK">前台</el-radio>
            <el-radio label="BOSS">老板/股东</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="负责的公寓" prop="companyIds">
          <el-checkbox-group v-model="form.companyIds">
            <el-checkbox v-for="c in companies" :key="c.companyId" :label="c.companyId">{{ c.companyName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="form.userId ? '重置密码' : '初始密码'" prop="password">
          <el-input size="small" v-model="form.password" show-password
                    :placeholder="form.userId ? '不改密码就留空' : '至少 6 位'"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userManageList, userManageCompanies, userManageSave } from '../../api/userMG'

export default {
  data() {
    return {
      loading: false,
      saving: false,
      users: [],
      companies: [],
      dialogVisible: false,
      form: { companyIds: [] },
      rules: {
        loginUsername: [{ required: true, message: '请输入登录名', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        companyIds: [{ type: 'array', required: true, min: 1, message: '至少选一家公寓', trigger: 'change' }],
        password: [{
          validator: (rule, value, callback) => {
            if (!value && this.form.userId) return callback()
            if (!value || value.length < 6) return callback(new Error('密码至少 6 位'))
            callback()
          },
          trigger: 'blur'
        }]
      }
    }
  },
  created() {
    this.load()
    userManageCompanies().then(res => {
      if (res.code === '200') this.companies = res.data
    })
  },
  methods: {
    load() {
      this.loading = true
      userManageList()
        .then(res => {
          this.loading = false
          if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
          this.users = res.data
        })
        .catch(() => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试')
        })
    },
    handleAdd() {
      this.form = { loginUsername: '', displayName: '', role: 'FRONT_DESK', companyIds: [], password: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.form = {
        userId: row.userId,
        loginUsername: row.loginUsername,
        displayName: row.displayName,
        role: row.role,
        // 只勾选自己能分配的公寓
        companyIds: row.companyIds.filter(id => this.companies.some(c => c.companyId === id)),
        password: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        userManageSave(this.form)
          .then(res => {
            this.saving = false
            if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
            this.dialogVisible = false
            this.$message({ type: 'success', message: '已保存' })
            this.load()
          })
          .catch(() => {
            this.saving = false
            this.$message.error('保存失败，请稍后再试')
          })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.hint {
  color: #909399;
  font-size: 12px;
}
.company-tag {
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/UserManage.vue